var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNeutralSmile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.996 10.7667C8.90516 10.7667 11.2635 8.40833 11.2635 5.49918C11.2635 2.59002 8.90516 0.231689 5.996 0.231689C3.08685 0.231689 0.728516 2.59002 0.728516 5.49918C0.728516 8.40833 3.08685 10.7667 5.996 10.7667ZM2.78076 4.92578C2.78076 4.64964 3.00462 4.42578 3.28076 4.42578H4.51374C4.78989 4.42578 5.01374 4.64964 5.01374 4.92578C5.01374 5.20192 4.78989 5.42578 4.51374 5.42578H3.28076C3.00462 5.42578 2.78076 5.20192 2.78076 4.92578ZM3.59961 8.05737C3.59961 7.78123 3.82347 7.55737 4.09961 7.55737H7.89364C8.16978 7.55737 8.39364 7.78123 8.39364 8.05737C8.39364 8.33352 8.16978 8.55737 7.89364 8.55737H4.09961C3.82347 8.55737 3.59961 8.33352 3.59961 8.05737ZM7.48389 4.42578C7.20774 4.42578 6.98389 4.64964 6.98389 4.92578C6.98389 5.20192 7.20774 5.42578 7.48389 5.42578H8.71687C8.99301 5.42578 9.21687 5.20192 9.21687 4.92578C9.21687 4.64964 8.99301 4.42578 8.71687 4.42578H7.48389Z",
    fill: "#9AAAB5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeutralSmile);
export default __webpack_public_path__ + "static/media/neutral-smile.48cd13c5a5cd5c5f2b169f3b6b076e13.svg";
export { ForwardRef as ReactComponent };